import React from 'react';
import '../css/Project.css';
import '../css/Collab.css';
import { Shape1, ShapeRectangle, Shape3 } from '../components/Shapes';
import ProductCard from '../components/ProductCard';
import emptyImage from '../assets/empty-image.webp';
import ContactForm from '../components/ContactForm';


const Cakes = () => {
  return (
    <div className="homepage">
      {/* Hero Section */}
      <header className="intro">
        <div className="shapes-container-inside blur-desktop blur-mobile">
          <ShapeRectangle className="shape shape-5" />
          <Shape3 className="shape shape-6" />
        </div>

        <div className="hero generic-hero">
          <h1>Baking small<br/> to serve it right</h1>
        </div>
      </header>

      <div className="shapes-container-outside">
        <Shape1 className="shape shape-1" />
        <ShapeRectangle className="shape shape-2" />
        <Shape3 className="shape shape-3" />
        <Shape1 className="shape shape-4" />
      </div>

      <section className="section-intro">
        <div className="challenges-content">
          <p>
            We're an Amsterdam-based micro-bakery crafting fresh, handcrafted pastries
            and baked goods using locally sourced ingredients whenever possible and
            careful, small-batch techniques. With a focus on quality and creativity,
            our goal is to deliver treats that are as memorable as they are delicious.
          </p>
        </div>
      </section>

      {/* Product offering Section */}
      <section className="case-studies">
        <div className="case-studies-grid">
          <div className="section-header">
            <h2>Cake menu</h2>
          </div>

          <div className="cases">
            <ProductCard
              productImage={emptyImage}
              productTitle="Small cake"
              retailLabel="From"
              retailPrice="€38"
              retailUnit="per cake"
              wholesaleLabel="Size"
              wholesalePrice="18 cm"
              wholesaleUnit="• 6–8 slices"
              description="Perfect for intimate celebrations or gifting."
              extraInfo="Custom flavours may change the price."
            />
            <ProductCard
              productImage={emptyImage}
              productTitle="Medium cake"
              retailLabel="From"
              retailPrice="€70"
              retailUnit="per cake"
              wholesaleLabel="Size"
              wholesalePrice="24 cm"
              wholesaleUnit="• 14–27 slices"
              description="A flexible option for most gatherings."
              extraInfo="Custom flavours may change the price."
            />
            <ProductCard
              productImage={emptyImage}
              productTitle="Large cake"
              retailLabel="From"
              retailPrice="€115"
              retailUnit="per cake"
              wholesaleLabel="Size"
              wholesalePrice="28×18 cm"
              wholesaleUnit="• 14–35 slices"
              description="Best for big celebrations and sharing."
              extraInfo="Custom flavours may change the price."
            />
          </div>
        </div>
      </section>

      
      <section className="outro">
        <div className="hero-outro">
            <h1>Get in touch with us!</h1>
            <section className="section-intro">
              <div className="challenges-content">
                <p>
                If you're interested in collaborating, have any questions or want to taste our menu send us a message!
                </p>
              </div>
              <div className='contact-form-block'>
                <ContactForm/>
              </div>

          <div className="contact-extra">
          <span className='contact-email'>Send us an e-mail at <a href="mailto:contact@chunksbakes.com" className="contact-email">
            contact@chunksbakes.com
          </a></span>
          <span className="contact-email " style={{ paddingTop: "20px" }}>
            Or find us on instagram <a href="https://www.instagram.com/chunks.delicious.bakes/" className="contact-email instagram-handle" target="_blank" rel="noopener noreferrer">
            @chunks.delicious.bakes
          </a>
          
          </span>
        </div>
        
      </section>
        </div>
      </section>
    </div>
  );
}

export default Cakes;

